import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const rating = css`
  position: absolute;
  top: ${spacing(-0.25)};
  right: ${spacing(-0.75)};
  padding: ${spacing(0.25, 0.75)};
  border-radius: 100px;
  background: white;
  box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
`
export const avatar = css`
  width: 100%;
  height: 100%;
  position: absolute;
`
